var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-barcode',{attrs:{"margin-left":"-8px","margin-bottom":"-4px","value":_vm.value,"tag":"svg","width":"2","height":"75","display-value":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }